import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { H3 } from 'foundations-components/transitional/components/H3';
import { Link } from 'foundations-components/transitional/components/Link';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { Fragment, useCallback } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { CallingIcon } from 'foundations-assets/icons/components/CallingIcon';
import { EmailIcon } from 'foundations-assets/icons/components/EmailIcon';
import { MessagesIcon } from 'foundations-assets/icons/components/MessagesIcon';
import { SocialBlockFacebookIcon } from 'foundations-assets/icons/components/SocialBlockFacebookIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NoopExternalIcon = () => null;
export default function AssetContactInfo({
  chatUrl,
  facebookUrl,
  getAssetEventSelectorId = () => '',
  onTrackInteraction,
  phone,
  provider,
  supportEmail
}) {
  const trackInteraction = useCallback(value => {
    if (onTrackInteraction) {
      onTrackInteraction(value);
    }
  }, [onTrackInteraction]);
  const {
    name: providerName
  } = provider;
  const [phoneNumber, phoneExtension] = phone ? phone.split('-') : [];
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(H3, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-assets-core.details.contact.title",
        options: {
          providerName
        }
      })
    }), /*#__PURE__*/_jsxs(List, {
      children: [/*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(EmailIcon, {}), /*#__PURE__*/_jsx(CopyButton, {
            "data-hs-analytics-id": getAssetEventSelectorId('SIDEBAR-EMAIL'),
            onClick: () => trackInteraction('click copy email address'),
            use: "link",
            value: supportEmail,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-ui-assets-core.details.contact.supportEmail"
            })
          })]
        })
      }), chatUrl && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(MessagesIcon, {}), /*#__PURE__*/_jsx(Link, {
            ExternalIcon: NoopExternalIcon,
            external: true,
            "data-hs-analytics-id": getAssetEventSelectorId('SIDEBAR-CHAT'),
            href: chatUrl,
            onClick: () => trackInteraction('click live chat link'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-ui-assets-core.details.contact.chatUrl"
            })
          })]
        })
      }), facebookUrl && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(SocialBlockFacebookIcon, {}), /*#__PURE__*/_jsx(Link, {
            ExternalIcon: NoopExternalIcon,
            external: true,
            "data-hs-analytics-id": getAssetEventSelectorId('SIDEBAR-FACEBOOK'),
            href: facebookUrl,
            onClick: () => trackInteraction('click facebook link'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-ui-assets-core.details.contact.facebookUrl"
            })
          })]
        })
      }), phone && /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(CallingIcon, {}), /*#__PURE__*/_jsx(Link, {
            ExternalIcon: NoopExternalIcon,
            external: true,
            "data-hs-analytics-id": getAssetEventSelectorId('SIDEBAR-PHONE'),
            href: `tel: ${phoneNumber}`,
            onClick: () => trackInteraction('click phone number link'),
            children: /*#__PURE__*/_jsx(FormattedPhoneNumber, {
              value: phoneNumber,
              extension: phoneExtension
            })
          })]
        })
      })]
    })]
  });
}